import GreenCheckIcon from "@/common/svgs/green-check";
import { Button } from "@/components/ui/button";
import { Entry } from "../models/entry";

type Props = {
	entries: Entry[];
	onSelect: (entry: Entry) => void;
};

export default function EntriesMobile({ entries, onSelect }: Props) {
	return (
		<div className="flex flex-col gap-4">
			{entries.map((entry) => (
				<div
					key={entry.id}
					className="bg-white-30 border-white-20 rounded-[24px] border p-4 text-left"
				>
					<div className="mb-3">
						<p className="web-body-b2-medium text-white">
							{entry.count} entries
						</p>
					</div>
					<div className="mb-3 flex flex-row items-center gap-2">
						<GreenCheckIcon transparent />
						<p className="web-body-b1 text-white-80">Access to {entry.draw}</p>
					</div>
					<div className="mb-4">
						<p className="web-body-b2-medium text-white">${entry.price}</p>
						<p className="web-body-b1 text-white-80">Once only payment</p>
					</div>
					<Button
						variant="secondary"
						className="bg-white-10 border-white-20 w-full text-white"
						onClick={() => onSelect(entry)}
					>
						Get entries
					</Button>
				</div>
			))}
		</div>
	);
}
